export default {
    namespaced: true,
  
    state: {
      isMobile: false,
      windowWidth: window.innerWidth,
      shrinkHeader: false,
      shrinkFooter: false
    },
  
    mutations: {

      updateWindowWidth(state, width) {
        state.windowWidth = width
        state.isMobile = state.windowWidth <= 700 ? true : false 
      },
  
      updateShrinkHeader(state, value) {
        state.shrinkHeader = value
      },
  
      updateShrinkFooter(state, value) {
        state.shrinkFooter = value
      }
    }
  }